import React from 'react'
import { connect } from 'react-redux'
import { Menu, Segment } from 'semantic-ui-react'
import { translate } from 'loankeeper-common/helpers'
import { LKIcon } from 'loankeeper-common/components'
import { colors } from 'shared'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
import { getPending } from 'loankeeper-common/helpers/SimpleFetchManager'
//@ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'
import ClientPermissionAdd, { ClientPermissionAddTrigger } from '../../../ClientPermissionsAdd'
import { actions as DetailsContainerActions, constants as DCConstants } from '../../../DetailsContainer'
import { translateLKMessage } from '../../helpers'

import { AccessPermissionsProps, StoreProps } from '../../types'
import { deletePermission as removePermission } from 'src/store/client'
import { AppDispatch } from 'src/store/index.d'

const FETCHER_NAME = 'ClientDeleteAccessPermission'

const LKGridConfig = {
  gridIdentity: { formName: 'frm_sec_RL', objectName: 'dbgrd_all' },
  syncGridState: true,
  enableRowSelection: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  getRowStyle: ({
    node: {
      data: { AGen },
    },
  }) => {
    if (AGen !== 0) {
      return { color: colors.grey }
    }

    return {}
  },
}

@withConstantPermissions(['ADD_RL as CanAdd', 'DEL_RL as CanDelete'])
//@ts-ignore
@connect(
  (state) => ({
    loading: getPending(FETCHER_NAME)(state),
  }),
  (dispatch: AppDispatch, ownProps: StoreProps) => ({
    openConfirmation: (ID: string) => {
      dispatch(
        LKModalActions.openConfirmation('ClientDeleteAccessPermission', {
          ID,
        }),
      )
    },

    deletePermission: async ({ ID }) => {
      // try {
      //   await dispatch(
      //     fetchSFM({
      //       instanceName: FETCHER_NAME,
      //       callApi: Client.deletePermission,
      //       callApiArgs: [
      //         {
      //           ClientID: ownProps.ID,
      //           HashSum_ClientID_: ownProps.hash,
      //           ID,
      //         },
      //       ],
      //     }),
      //   )
      //   dispatch(
      //     DetailsContainerActions.fetchPage({
      //       type: 'Client',
      //       ID: ownProps.ID,
      //       hash: ownProps.hash,
      //       page: 'accessperms',
      //       permission: 'VIEW_RL',
      //     }),
      //   )
      // } catch (error) {
      //   dispatch(LKModalActions.openInfo(translateLKMessage(error.Error.Message || error.Error.Text)))
      // }

      //UPDATED API REQUEST client_oper_api page: accesspermdelete
      try {
        const res = await dispatch(
          removePermission({
            ClientID: ownProps.ID,
            HashSum_ClientID_: ownProps.hash,
            ID,
          }),
        )
        if (removePermission.fulfilled.match(res)) {
          dispatch(
            DetailsContainerActions.fetchPage({
              type: 'Client',
              ID: ownProps.ID,
              hash: ownProps.hash,
              page: 'accessperms',
              permission: 'VIEW_RL',
            }),
          )
        } else if (removePermission.rejected.match(res)) {
          dispatch(LKModalActions.openInfo(translateLKMessage(res.payload as string)))
        }
      } catch (error) {
        dispatch(LKModalActions.openInfo(translateLKMessage(error?.Error?.Message || error?.Error?.Text)))
      }
    },
  }),
)
class AccessPermissions extends React.PureComponent<AccessPermissionsProps> {
  static defaultProps = {
    data: [],
  }

  getContextMenu = ({
    node: {
      data: { AGen, SEC_UserID },
    },
  }) => {
    const result = []

    if (this.props.CanDelete) {
      result.push({
        name: translate('frm_sec_RL-cmd_delete'),
        icon: 'delete',
        disabled: AGen !== 0,
        action: () => this.props.openConfirmation(SEC_UserID),
      })
    }

    return result
  }

  render() {
    const { data, loading, ID, hash, CanAdd } = this.props
    return (
      <div className="u-flex u-directionColumn u-fluid u-marginRight-20">
        <LKModal.Confirmation
          name="ClientDeleteAccessPermission"
          onConfirm={this.props.deletePermission}
          loading={loading}
        />

        <Menu attached="top">
          <Menu.Item className="u-noPadding u-paddingRight-15 u-paddingLeft-5">
            <LKIcon alias="key" style={{ marginRight: 5 }} />

            {translate('frm_sec_RL-frm_sec_RL')}
          </Menu.Item>
        </Menu>

        <Segment className="u-marginBottom-5 u-noPadding u-fluid" attached="bottom">
          <LKGrid
            instanceName={`${DCConstants.DetailsGridPrefixes.client}-${ID}-AccessPermissions`}
            rowData={data}
            getContextMenuItems={this.getContextMenu}
            {...LKGridConfig}
          />
        </Segment>

        <div>
          {CanAdd && <ClientPermissionAddTrigger>{translate('frm_sec_RL-cmd_add')}</ClientPermissionAddTrigger>}

          <ClientPermissionAdd addedPermissions={data} ID={ID} hash={hash} />
        </div>
      </div>
    )
  }
}

export default AccessPermissions
